<script lang="ts">
    // set 404 for ssr
    if (typeof window === "undefined") {
        // @ts-ignore
        if (context) context.is404 = true
    }
</script>

<svelte:head>
    <meta name="robots" content="noindex" />
</svelte:head>

<div class="wrapper">
    <div class="site-content">
        <h1>404</h1>
        <h2>Seite nicht gefunden - Site not found</h2>
        <p>&nbsp;</p>
    </div>
</div>
